import { render, staticRenderFns } from "./LoginPasswordAuth.vue?vue&type=template&id=a2749436"
import script from "./LoginPasswordAuth.vue?vue&type=script&lang=js"
export * from "./LoginPasswordAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports